import React, { useRef } from "react";
import clsx from "clsx";

import * as ReactUtils from "../../../lib/util/ReactUtils";

const VisibleContext = ReactUtils.VisibleContext;

export interface OverlayProps
	extends Omit<React.HTMLProps<HTMLDivElement>, "type" | "content"> {
	visible?: boolean;
	className?: string;
}

const Overlay = (props: OverlayProps) => {
	let { children, visible, className } = props;
	const shown = useRef(false);

	if (visible === undefined) {
		visible = true;
	}

	if (visible) {
		shown.current = true;
	}

	return shown.current ? (
		<div className={clsx("Overlay", visible && "--visible", className)}>
			<VisibleContext.Provider value={visible}>
				<div className={"Overlay__container"}>
					{children && <div className={"Overlay__content"}>{children}</div>}
				</div>
			</VisibleContext.Provider>
		</div>
	) : (
		<div className={"Overlay__stub"} />
	);
};

export default React.memo(Overlay);
